// extracted by mini-css-extract-plugin
module.exports = {"example-runner-result":"g_D"};